import { HeaderElement, HeaderElementType } from "src/types";

const resourcesHeader = {
  title: 'Resources',
  redirectLink: '',
  actionType: HeaderElementType.DRPODOWN,
  dropdown: [
    {
      title: 'Request Form',
      redirectLink: '/assets/completed-request.pdf',
    },
    {
      title: 'Reimbursement Guide',
      redirectLink:'/assets/SMK-005000-StimRouterReimbursementGuide2024-RevB.pdf'
    },
    {
      title: 'Statement of Medical Necessity',
      redirectLink:'/assets/MP918-00044-001-Rev.-D-efile-2.pdf'
    },
  ]
};
export const PublicHeader: HeaderElement[] = [
  {
    title: 'Welcome',
    redirectLink: '/users/sign_in',
    actionType: HeaderElementType.ROUTE,
  },
  {
    title: 'Enrollment',
    redirectLink: '/enrollments/new',
    actionType: HeaderElementType.ROUTE,
  },
];

export const AuthenticatedManufactureHeader: HeaderElement[] = [
  
  {
    title: 'Statistics',
    redirectLink: '/statistics',
    actionType: HeaderElementType.ROUTE,
  },
  {} as unknown as HeaderElement,
  resourcesHeader,
];
export const AuthenticatedHCPHeader: HeaderElement[] = [
  
  {
    title: 'Cases',
    redirectLink: '/cases',
    actionType: HeaderElementType.ROUTE,
  },
  {
    title: 'Submit a Request',
    redirectLink: '/cases/new',
    actionType: HeaderElementType.ROUTE,
  },
  resourcesHeader,
  
];


